import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=6456eea5&scoped=true"
import script from "./footBar.vue?vue&type=script&lang=js"
export * from "./footBar.vue?vue&type=script&lang=js"
import style0 from "./footBar.vue?vue&type=style&index=0&id=6456eea5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456eea5",
  null
  
)

export default component.exports